import React from 'react';

export const Templates = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '24'}
    height={height || '25'}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.69897V18.699H20V6.69897H4ZM3 4.69897C2.44772 4.69897 2 5.14669 2 5.69897V19.699C2 20.2513 2.44772 20.699 3 20.699H21C21.5523 20.699 22 20.2513 22 19.699V5.69897C22 5.14669 21.5523 4.69897 21 4.69897H3Z"
      fill={color || '#5D54C0'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.91504 20.3486L7.91504 5.04944L9.91504 5.04944L9.91504 20.3486L7.91504 20.3486Z"
      fill={color || '#5D54C0'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.38489 10.6389L21.4658 10.6389V12.6389L2.38489 12.6389V10.6389Z"
      fill={color || '#5D54C0'}
    />
  </svg>
);
